import type { ThemeConfig } from "antd";
import { theme as antdTheme } from "antd";

// Build theme config dựa trên dark/light mode.
// Sider luôn giữ tone tối (kiểu admin classic) cả ở light mode.
export function buildAntdTheme(isDark: boolean): ThemeConfig {
  return {
    algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
    token: {
      colorPrimary: "#2563EB",
      colorInfo: "#2563EB",
      colorSuccess: "#16A34A",
      colorWarning: "#EA580C",
      colorError: "#DC2626",
      borderRadius: 8,
      fontFamily:
        '"DM Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      fontSize: 14,
    },
    components: {
      Layout: {
        siderBg: "#0F172A",
        headerBg: isDark ? "#0F172A" : "#FFFFFF",
        headerHeight: 56,
        headerPadding: "0 16px",
      },
      Menu: {
        darkItemBg: "#0F172A",
        darkSubMenuItemBg: "#0F172A",
        darkItemSelectedBg: "#1E40AF",
      },
      Table: {
        headerBg: isDark ? "#1E293B" : "#F8FAFC",
        borderColor: isDark ? "#334155" : "#E2E8F0",
      },
    },
  };
}
